import { render } from "./ToLike.vue?vue&type=template&id=71b24e82&scoped=true"
import script from "./ToLike.vue?vue&type=script&lang=js"
export * from "./ToLike.vue?vue&type=script&lang=js"

import "./ToLike.vue?vue&type=style&index=0&id=71b24e82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b24e82"]])

export default __exports__